import { createDataFetchSlice } from '../../../utils/dataFetch';
import { ClientAccountViewModel } from '../../../../common/model/client/clientAccountViewModel';

export const clientAccountsSlice = createDataFetchSlice<
    ClientAccountViewModel[]
>({ name: 'clientAccounts' });
